import React from 'react';
import { Button } from '../../../UI';
import UserSettingsContent from '../UserSettingsContent';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { toggleFileExplorer } from '../../../../store/app/slice';
import NavLinks from '../NavLinks/NavLinks';
import styles from './MobileMenu.module.scss';
import IconClose from '../../../Icon/IconClose';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onShowHistory: () => void;
  isChatPage: boolean;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose, onShowHistory, isChatPage }) => {
  const dispatch = useAppDispatch();
  const { selectedCompanies } = useAppSelector((state) => state.company);
  const showFileExplorerButton = selectedCompanies.length > 0;

  if (!isOpen) return null;

  return (
    <>
      <div className={styles.mobileMenu}>
        <div className={styles.mobileMenuContent}>
          <Button
            variant="ghost"
            size="small"
            onClick={onClose}
            aria-label="Close"
            icon={<IconClose />}
            className={styles.closeButton}
          />
          <NavLinks onLinkClick={onClose} direction="column" />
          <div className={styles.actions}>
            {showFileExplorerButton && (
              <Button
                variant="ghost"
                fullWidth
                onClick={() => {
                  onClose();
                  dispatch(toggleFileExplorer());
                }}
              >
                File Explorer
              </Button>
            )}
            {isChatPage && (
              <Button
                variant="ghost"
                fullWidth
                onClick={() => {
                  onClose();
                  onShowHistory();
                }}
              >
                Chat History
              </Button>
            )}
          </div>
          <div className={styles.mobileUserSection}>
            <UserSettingsContent onClose={onClose} />
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
